export enum NugetType {
    Packages = 'packages',
    Libraries = 'libraries',
}

export interface IPackage {
    id: string;
    description: string;
    version: string;
    key: string;
    published: Date;
    isLatestVersion: boolean;
    isActive: boolean;
    releaseNotes: string;
    authors: string;
    arguments: IPackageArgumentCollection;
}

export interface IPackageArgumentCollection {
    input: IPackageArgument[];
    output: IPackageArgument[];
}

export interface IPackageArgument {
    name: string;
    type: string;
    required: boolean;
    hasDefault: boolean;
    source: 'package' | 'process' | null;
    value: string | boolean | number | Object | null;
}

export interface IProcessBulkUpdateOperationResponse {
    FailedItems: number[];
    Message?: string;
    Success: boolean;
}

export interface IPackageInfo {
    id: string;
    version: string;
}
